// ViewUserData.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { database } from "../firebase"; // Ensure this imports your Firebase config

const pronounsMap = [
  { code: "001", label: "they/them/theirs" },
  { code: "002", label: "she/her/hers" },
  { code: "003", label: "he/him/his" },
  { code: "004", label: "it/its/its" },
  { code: "005", label: "xe/xem/xys" },
  { code: "006", label: "ey/em/eirs" },
  { code: "007", label: "xe/xer/xers" },
  { code: "008", label: "fae/faer/faers" },
  { code: "051", label: "Any Pronouns" },
  { code: "052", label: "No Pronouns" },
  { code: "053", label: "Ask Pronouns" },
  { code: "101", label: "היא/את" },
  { code: "102", label: "הוא/אתה" },
  { code: "103", label: "הן/אתן" },
  { code: "104", label: "הם/אתם" },
  { code: "105", label: "זה" },
  // Add more pronouns as needed
];

const flagsMap = [
  { code: "001", label: "Transgender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transgender.png` },
  { code: "002", label: "Transfeminine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transfeminine.png` },
  { code: "003", label: "Transneutral", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transneutral.png` },
  { code: "004", label: "Transmasculine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transmasculine.png` },
  { code: "005", label: "Non-Binary", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Nonbinary.png` },
  { code: "006", label: "Agender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Agender.png`},
  { code: "007", label: "Librafeminine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Librafeminine.png`},
  { code: "008", label: "Libranrdogyne", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Librandrogyne.png`},
  { code: "009", label: "Libramasculine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Libramasculine.png`},
  { code: "010", label: "Demigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demigender.png`},
  { code: "011", label: "Demigirl", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demigirl.png`},
  { code: "012", label: "Demiboy", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demiboy.png`},
  { code: "013", label: "Paragirl", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Paragirl.jpg`},
  { code: "014", label: "Paraboy", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Paraboy.jpg`},
  { code: "015", label: "Androgyne", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Androgyne.png`},
  { code: "016", label: "Genderqueer", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderqueer.png`},
  { code: "017", label: "Genderfluid", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderfluid.png`},
  { code: "018", label: "Neutrois", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Neutrois.png`},
  { code: "019", label: "Bigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Bigender.png`},
  { code: "020", label: "Trigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Trigender.png`},
  { code: "021", label: "Polygender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Polygender.png`},
  { code: "022", label: "Pangender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Pangender.png`},
  { code: "023", label: "Two Spirit", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Two Spirit.png`},
  { code: "025", label: "Xenogender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Xenogender.png`},
  { code: "026", label: "Genderfae", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderfae.png`},
  { code: "027", label: "Trans Flag Israel", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Trans Flag Israel.png`},
  { code: "028", label: "Israeli Trans Flag GR", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Israeli Trans Flag GR.png`},
  { code: "101", label: "Intersex", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/I-Intersex.png`},
  { code: "201", label: "LGBTQ", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-LGBTQ.png`},
  { code: "202", label: "Lesbian", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Lesbian.png`},
  { code: "203", label: "Sapphic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Sapphic.png`},
  { code: "204", label: "Enbian", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Enbian.png`},
  { code: "205", label: "Gay", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Gay.png`},
  { code: "206", label: "Achillean", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Achillean.png`},
  { code: "207", label: "Bisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Bisexual.png`},
  { code: "208", label: "Polysexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Polysexual.png`},
  { code: "209", label: "Omnisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Omnisexual.png`},
  { code: "210", label: "Pansexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Pansexual.png`},
  { code: "211", label: "Abrosexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Abrosexual.png`},
  { code: "212", label: "Asexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Asexual.png`},
  { code: "213", label: "Demisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Demisexual.png`},
  { code: "214", label: "Aromantic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Aromantic.png`},
  { code: "215", label: "Demiromantic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Demiromantic.png`},
  { code: "216", label: "Polyamorous", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Polyamorous.png`},
  { code: "301", label: "Neopronouns", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Neopronouns.png`},
  { code: "302", label: "Progress Pride IC", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Progress Pride IC.png`},
  { code: "303", label: "Progress Pride", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Progress Pride.png`},
  { code: "304", label: "Hostages Stripe Rainbow Flag", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Hostages Stripe Rainbow Flag.jpg`},
  { code: "305", label: "Rainbow Israel Flag", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Rainbow Israel Flag.png`},
  { code: "306", label: "Unlabeled", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Unlabeled.png` },
  // Add more flags as needed
];

const ViewUserData = () => {
  const { username } = useParams(); // Get the username from URL
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const usersRef = database.ref('users');
    usersRef.orderByChild('nickname').equalTo(username).once('value', (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const userKey = Object.keys(data)[0];
        setUserData(data[userKey]);
      } else {
        console.error('User not found');
      }
      setLoading(false);
    });
  }, [username]);

  if (loading) return <div>Loading...</div>;
  if (!userData) return <div>User not found.</div>;

  // Convert pronouns codes to labels
  const pronouns = userData.pronounscard.pronouns.map(code => {
    const pronoun = pronounsMap.find(p => p.code === code);
    return pronoun ? pronoun.label : code; // Return the label or the code if not found
  }).join(', ');

  // Convert flags codes to labels and image URLs
  const flagsImages = userData.pronounscard.flags.map(code => {
    const flag = flagsMap.find(f => f.code === code);
    return flag ? flag : null; // Return flag object or null if not found
  });

  // Access card image from pronounscard folder
  const cardImage = userData.pronounscard.profileImage;
  const renderTextWithLinksAndLineBreaks = (text) => {
    // Split the text by newlines
    return text.split('\n').map((line, index) => {
      // Convert URLs in the line to <a> tags
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      const lineWithLinks = line.replace(urlPattern, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });

      // Return the line with line breaks and converted links
      return (
        <span key={index}>
          <span dangerouslySetInnerHTML={{ __html: lineWithLinks }} />
          <br />
        </span>
      );
    });
  };

  return (
    <div className="pronouns-card" style={{fontFamily: 'Rubik-Regular'}}>
      {cardImage && <img className="user-image" src={cardImage} alt={`${userData.nickname}'s card`} />}
      <h1>{userData.nickname}</h1>
      <div className="pronouns-info">
      <h2 style={{fontFamily: 'Rubik-Medium'}}>Timezone</h2>
        <p>{userData.pronounscard.timezone}</p>
        <h2 style={{fontFamily: 'Rubik-Medium'}}>Tier</h2>
        <p>{userData.tier}</p>
        <h2 style={{ fontFamily: 'Rubik-Medium' }}>Description</h2>
      <p style={{ direction: 'auto' }}>
        {renderTextWithLinksAndLineBreaks(userData.pronounscard.description)}
      </p>
        <h2 style={{fontFamily: 'Rubik-Medium'}}>Pronouns</h2>
        <p>{pronouns}</p>
        <h2 style={{fontFamily: 'Rubik-Medium'}}>Flags</h2>
        <div className="flags-container">
  {flagsImages.map((flag, index) => (
    flag ? (
      <div key={index} className="flag-item">
        <img src={flag.imageUrl} alt={`Flag ${index + 1}`} className="flag-image" />
        <span className="flag-label" style={{fontSize: '16px'}}>{flag.label}</span>
      </div>
    ) : null
  ))}
</div>
        
      </div>
    </div>
  );
};

export default ViewUserData;
